import { Avatar, Button, Flex, PasswordInput, TextInput } from "@mantine/core";
import { useAuth } from "../context/AuthContext";
import styled from "styled-components";
import { useForm } from "@mantine/form";
import {
  combineValidators,
  validateMinLength,
  validateNoSpaces,
  validatePhoneNumberIsNumeric,
  validatePhoneNumberStartsWithZero,
  validateRequired,
} from "../utils/validations";
import { formatTerminalCode } from "../utils/textUtils";

const normalizePhone = (phone: string): string => {
  if (!phone) return "";
  if (phone.startsWith("0")) return "+90" + phone.slice(1);
  if (phone.startsWith("90")) return "+" + phone;
  return phone;
};

const LoginPage = () => {
  const { login } = useAuth();

  const form = useForm({
    initialValues: {
      username: "",
      phone: "",
      password: "",
    },
    validate: {
      username: validateRequired,
      phone: combineValidators(
        validateRequired,
        validatePhoneNumberStartsWithZero,
        validatePhoneNumberIsNumeric,
        validateNoSpaces,
        validateMinLength(11)
      ),
      password: combineValidators(validateRequired, validateNoSpaces),
    },
  });

  const handleSubmit = async ({ username, phone, password }: any) => {
    const formattedPhone = normalizePhone(phone);
    login(`${username}`, `${formattedPhone}`, `${password}`);
  };

  return (
    <LoginPageWrapper>
      <LogoWrapper>
        <Avatar src={"/assets/kronifyLogo.png"} size={60} />
        <LogoText>Kronify Admin</LogoText>
      </LogoWrapper>
      <form
        style={{
          width: "min(380px, 90%)",
          borderRadius: "10px",
          display: "flex",
          flexDirection: "column",
          gap: "20px",
        }}
        onSubmit={form.onSubmit(handleSubmit)}
      >
        <LoginText>Giriş Yap</LoginText>
        <TextInput
          label="Kullanıcı Adı"
          placeholder="Kullanıcı adını giriniz."
          radius={10}
          size="md"
          {...form.getInputProps("username")}
          // onChange={(event) => {
          //   form.setFieldValue(
          //     "username",
          //     formatTerminalCode(event?.target?.value)
          //   );
          // }}
        />
        <TextInput
          label="Telefon Numarası"
          placeholder="05*********"
          radius={10}
          size="md"
          maxLength={11}
          {...form.getInputProps("phone")}
        />
        <PasswordInput
          label="Şifre"
          placeholder="*****"
          radius={10}
          size="md"
          maxLength={16}
          {...form.getInputProps("password")}
        />
        <Button type="submit" fullWidth h={44} radius={10} color="#5C26FF">
          <Flex gap={12} align={"center"} justify={"center"}>
            <ButtonLabel>Giriş Yap</ButtonLabel>
            <Avatar src={"/assets/arrowIcon.png"} size={24} radius={0} />
          </Flex>
        </Button>
      </form>
    </LoginPageWrapper>
  );
};
export default LoginPage;

const LoginPageWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 93px;
  height: 100vh;
`;

const ButtonLabel = styled.label`
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
`;

const LoginText = styled.div`
  display: flex;
  align-self: center;
  font-size: 28px;
  font-weight: 600;
  line-height: 24px;
  color: black;
`;

const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;

const LogoText = styled.div`
  color: #5c26ff;
  font-size: 60px;
  font-weight: 600;
  line-height: 45px;
`;
